import React from 'react';
import Icon from '@/v2/components/atoms/Icon';

import './SmartHome.scss';

const SmartHome = (props) => (
    <Icon iconName="SmartHome" {...props}>
        <svg width="31px" height="43px" viewBox="0 0 31 43" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="1440-/-Connectivity-/-Intro-01" transform="translate(-1007.000000, -445.000000)">
                    <g id="Icons-/-Smart-Home" transform="translate(1008.000000, 446.000000)">
                        <path
                            d="M-5.81756865e-13,25.2785 L13.0625,14.62225 C13.85625,14.01975 14.95375,14.01975 15.74875,14.62225 L28.81125,25.2785"
                            id="Stroke-1"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            d="M8.207375,34.604125 L6.576125,34.604125 C5.367375,34.604125 4.387375,33.624125 4.387375,32.415375 L4.387375,22.096625"
                            id="Stroke-3"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            d="M24.49775,22.09675 L24.49775,32.41425 C24.49775,33.62425 23.5165,34.60425 22.30775,34.60425 L20.679,34.60425"
                            id="Stroke-5"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M18.03525,41.028125 L10.77525,41.028125 C9.83525,41.028125 9.07275,40.265625 9.07275,39.324375 L9.07275,24.196875 C9.07275,23.255625 9.83525,22.493125 10.77525,22.493125 L18.03525,22.493125 C18.9765,22.493125 19.739,23.255625 19.739,24.196875 L19.739,39.324375 C19.739,40.265625 18.9765,41.028125 18.03525,41.028125 Z"
                            id="Stroke-7"
                            stroke="#000000"
                            strokeWidth="1.5"
                        />
                        <line x1="9.07225" y1="25.2785" x2="19.73975" y2="25.2785" id="Stroke-9" stroke="#000000" strokeWidth="1.5" strokeLinecap="round" />
                        <line
                            x1="9.108875"
                            y1="36.61275"
                            x2="19.521375"
                            y2="36.61275"
                            id="Stroke-11"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M15.18125,38.7685 C15.18125,39.20225 14.83375,39.5535 14.405,39.5535 C13.9775,39.5535 13.63,39.20225 13.63,38.7685 C13.63,38.33475 13.9775,37.9835 14.405,37.9835 C14.83375,37.9835 15.18125,38.33475 15.18125,38.7685"
                            id="Fill-13"
                            fill="#000000"
                        />
                        <path
                            d="M10.52,10.5575 C11.8,10.04125 13.16,9.76375 14.57125,9.76375 C15.885,9.76375 17.15625,10.005 18.35875,10.455"
                            id="Stroke-15"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M7.955375,6.794625 C9.987875,5.679625 12.224125,5.062125 14.570375,5.062125 C16.764125,5.062125 18.860375,5.600875 20.784125,6.582125"
                            id="Stroke-17"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                        <path
                            // eslint-disable-next-line
                            d="M5.643375,2.6925 C8.334625,0.96875 11.365875,2.84217094e-13 14.570875,2.84217094e-13 C17.698375,2.84217094e-13 20.658375,0.92125 23.299625,2.56625"
                            id="Stroke-19"
                            stroke="#000000"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                        />
                    </g>
                </g>
            </g>
        </svg>
    </Icon>
);

export default SmartHome;
